<div class="title">О хоккейной лиге “Трудовые резервы”</div>
<div class="text">
  <p>
  Четвертый сезон Хоккейной Лиги «Трудовые Резервы» среди любительских команд стартует 23 сентября.
  </p>
  <p>
  В сезоне 2023-2024  примут участие 112 команд в составе 14 дивизионов встретятся на льду лучших спортивных площадок, таких как «Чкалов Арена», «ЛД Триумф», «Арена Play Юг», «Арена Play Север» и УДС «Янтарь», и в течение 26 игровых недель будут бороться за победу в олимпийском виде спорта. За главные призы будут соревноваться спортсмены-любители из таких компаний и организаций, как Госкорпорация Ростех, АО «Рособоронэкспорт», ПАО «Промсвязьбанк», АО «ОЭК», АО «Технодинамика» и многие другие.
  Всего хоккеистов ждет три этапа: отборочный-квалификационный раунд, регулярный чемпионат и стадия плей-офф. Финальные матчи золотого плей-офф пройдут в марте-апреле на олимпийских объектах в Сочи. Каждая игра турнира будет длиться три периода по 20 минут «чистого игрового времени» с перерывом 15 минут на заливку и уборку льда после первого периода. Всем участникам будет предоставлена вода в раздевалке перед началом встречи, а на разминку - шайбы. Все матчи турнира будут обслуживать профессиональные бригады судей Федерации Хоккея Москвы и Федерации Хоккея России. Лучшим игрокам по итогам каждого матча вручаются памятные призы и полезные подарки.
  </p>
  <p>
  Медиаслужба Лиги будет полностью освещать чемпионат. Каждый матч турнира будет показан в прямом эфире на YouTube-канале с профессиональными комментаторами. На YouTube-канале можно найти хайлайты лучших моментов каждой встречи. Кроме видеоматериалов, с каждой игры будут яркие и профессиональные фотоотчеты. Но важной особенностью Лиги является уникальная статистика, которая ведется на протяжении всех матчей чемпионата. На официальном сайте можно отследить подробную статистику по каждой команде и отдельно взятому игроку
  </p>
</div>

<div class="statistic-wrapper">
  <div class="link-tabs">
    <div class="item"
      *ngFor="let item of tournaments"
    >
      <a
        href="javascript:;"
        (click)="getSeasonStatistic(item.id)"
        [ngClass]="{active: tournamentId === item.id}"
      >
        {{ item.season.name }}
        <mtg-svg-icon *ngIf="(rounds[item.id] || []).length > 1" icon="icons-selector-down"></mtg-svg-icon>
      </a>
      <div class="sub-menu" *ngIf="(rounds[item.id] || []).length > 1">
        <a href="javascript:;"
          *ngFor="let round of (rounds[item.id] || [])"
           (click)="getSeasonStatistic(item.id, round.id)"
           [ngClass]="{active: roundId === round.id}"
        >{{ round.name }}</a>
      </div>
    </div>
    <div class="item">
      <a
        href="javascript:;"
        (click)="getSeasonStatistic()"
        [ngClass]="{active: allStatistic}"
      >За всё время</a>
    </div>
  </div>
  <div class="statistic">
    <div class="item">
      <div class="name">
        Количество
        <br />
        проведённых матчей
      </div>
      <div class="value">{{ statistic?.games_count || 0 }}</div>
    </div>
    <div class="item">
      <div class="name">
        Количество
        <br />
        заброшенных шайб
      </div>
      <div class="value">{{ statistic?.goals || 0 }}</div>
    </div>
    <div class="item">
      <div class="name">
        Количество
        <br />
        отраженных бросков
      </div>
      <div class="value">{{ statistic?.saves || 0 }}</div>
    </div>
    <div class="item">
      <div class="name">
        Количество
        <br />
        голевых передач
      </div>
      <div class="value">{{ statistic?.assists || 0 }}</div>
    </div>
    <div class="item">
      <div class="name">
        Количество
        <br />
        игровых дней
      </div>
      <div class="value">{{ statistic?.game_days || 0 }}</div>
    </div>
  </div>
</div>

<div class="join">
  Присоединяйся к Хоккейной Лиге "Трудовые резервы"
  <a href="javascript:;" class="btn" (click)="openJoinForm()">Присоединиться</a>
</div>
